import { NewTask, Task } from "../models/tasks.models";

export const isNewTask = (task: NewTask | Task): task is NewTask => !("id" in task) || !task.id;

export const isTask = (task: NewTask | Task): task is Task => "id" in task && !!task.id;
